import { USER_STATUS } from '../constants/roles';
import { getItemOrDefaultToValue, getPersonName } from '../details';
import { severityRatingEnums } from 'containers/Pages/Events/Layouts';
import { displayTime } from '../time';
import { BASE_INCIDENT_STATUS } from '../constants/eventStatus';
import isEmpty from 'lodash/isEmpty';
import { ASSET_STATUS } from 'containers/Pages/Assets/Assets/helper';

export const transformPersonnelDashboard = ({ personnelList, roles }) => {
  // key is the role name
  // then each status is hardcoded with a value of 0 and replaced based on the available data
  return roles.map(r => {
    let a = '';
    let u = '';
    let l = '';
    let t = '';
    let c = '';
    let b = '';
    personnelList.dashboardItems.forEach(i => {
      if (i.role === r) {
        switch (i.status) {
          case USER_STATUS.AVAILABLE.id:
            a = i.count;
            break;
          case USER_STATUS.UNAVAILABLE.id:
            u = i.count;
            break;
          case USER_STATUS.NOT_LOGGED_IN.id:
            l = i.count;
            break;
          case USER_STATUS.ON_INTERRUPTABLE_TASK.id:
            t = i.count;
            break;
          case USER_STATUS.ON_TASK.id:
            c = i.count;
            break;
          case USER_STATUS.ON_BREAK.id:
            b = i.count;
            break;
          default:
          //do nothing
        }
      }
    });
    return {
      id: r,
      available: a,
      loggedOut: l,
      task: t,
      criticalTask: c,
      unavailable: u,
      break: b,
    };
  });
};
export const transformAssetDashboard = ({ assetList, categories }) => {
  // key is the category name
  if (isEmpty(categories)) return [];
  // then each status is hardcoded with a value of 0 and replaced based on the available data
  return categories.map(cat => {
    let a = '';
    let d = '';
    let iu = '';
    let r = '';
    let u = '';
    let ur = '';
    assetList.dashboardItems.forEach(i => {
      if (i.category === cat) {
        switch (i.status) {
          case ASSET_STATUS.AVAILABLE.id:
            a = i.count;
            break;
          case ASSET_STATUS.UNAVAILABLE.id:
            u = i.count;
            break;
          case ASSET_STATUS.DEPLOYING.id:
            d = i.count;
            break;
          case ASSET_STATUS.RETURNING.id:
            r = i.count;
            break;
          case ASSET_STATUS.IN_USE.id:
            iu = i.count;
            break;
          case ASSET_STATUS.UNREGISTERED.id:
            ur = i.count;
            break;
          default:
          //do nothing
        }
      }
    });
    return {
      id: cat,
      available: a,
      inUse: iu,
      deploying: d,
      returning: r,
      unavailable: u,
      unregistered: ur,
    };
  });
};
const getAddress = locations => {
  if (!isEmpty(locations)) {
    if (locations[0].address) return locations[0].address;
  }
  return '';
};
export const transformEventDashboard = ({ eventList, timeZone }) => {
  const displayFormat = 'HH:mm DD/MMM/YYYY';
  return eventList.map(data => ({
    id: data.general.id,
    title: getItemOrDefaultToValue(data.general, 'title', '-'),
    type: getItemOrDefaultToValue(data.general, 'type', '-'),
    creatorName: getPersonName(data.general.creator.general),
    thumbnail: data.general.thumbnail,
    lastUpdatedTime: displayTime({
      timestamp: getItemOrDefaultToValue(data.publishing, 'lastUpdatedAt', '-'),
      format: displayFormat,
      timeZone,
    }),
    severityRating:
      data.general.severityRating !== null && data.general.severityRating !== ''
        ? getItemOrDefaultToValue(
            data.general,
            'severityRating',
            severityRatingEnums.notRated,
          )
        : severityRatingEnums.notRated,
    status: data.general.incidentStatus
      ? BASE_INCIDENT_STATUS[data.general.incidentStatus].value
      : '-',
    address: getAddress(data.locations),
  }));
};
